import {WixSdk} from '@wix/js-sdk-wrapper';
import {Player} from '@wix/music-player';
import throttle from 'lodash/throttle';
import {showFeatureDisabledPopup} from './popus/featureDisabledPopup';
import {showGetWindow} from './popus/showGetWindow';
import {showModal} from './popus/widgetPlayerModal';

export function subscribeToPlayerEvents(player: Player) {
  player.on('modal', WixSdk.openModal);
  player.on('popup', WixSdk.openPopup);
  player.on('closePopup', WixSdk.closeWindow);
  player.on('mobile.setHeight', () => {
    WixSdk.setHeight(player.getDimensions().maxHeight);
  });

  player.on('widget:share', showModal('share'));
  player.on('widget:track-info', showModal('track-info'));
  player.on('widget:get-window', showGetWindow);
  player.on('feature-disabled', showFeatureDisabledPopup);
  player.on(
    'timeupdate',
    throttle(
      (currentTime, playingProgress, currentTrackId, playedTime) => {
        const {album} = player;

        player.statisticEvents.emit('trackTimePlayed', {
          album,
          playedTime,
          track: album.tracks.find((track) => track.id === currentTrackId),
        });
      },
      5 * 1000,
      {
        leading: false,
      },
    ),
  );

  const events = ['playing', 'pause', 'playbacktoggle', 'timeupdate', 'progress', 'prev', 'next', 'shuffle', 'loop'];

  events.forEach((event) => {
    player.on(event, (...args) => {
      WixSdk.PubSub.publish(event, args);
    });
  });
}
